var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111.239,
    height: 112.766,
    viewBox: "0 0 111.239 112.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1762",
    "data-name": "Rectangle 1762",
    width: 84.347,
    height: 80.432,
    fill: "#222"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1871",
    "data-name": "Group 1871",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 0, 73.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1870",
    "data-name": "Group 1870",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2754",
    "data-name": "Path 2754",
    d: "M1.271,65.542c.941.377,1.859.776,2.765,1.191A79.238,79.238,0,0,1,21.886,79.9c1.78,1.733,4.884-1.159,3.187-3.025-.127-.143-.263-.272-.39-.412l-.022-.019A59.469,59.469,0,0,0,12.712,66.407c36.4-.07,74.132-23.759,71.6-65.2.333-1.384-1.774-1.685-2.154-.364C78.238,40.214,44.7,64.564,8.015,61.821Q17.133,54.76,26.247,47.7a2.226,2.226,0,0,0-2.626-3.592Q12.594,51.724,1.565,59.343A1.955,1.955,0,0,0,.8,61.8a2.233,2.233,0,0,0,.469,3.741",
    transform: "translate(-0.001 0)",
    fill: "#222"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.0a046fdc07664942d7e85b401e79ee22.svg";
export { ForwardRef as ReactComponent };